
<div class="flex flex-col gap-16 mt-24 md:flex-row md:gap-64">
  <div class="w-full top-128 self-start md:max-w-[40%] md:sticky">
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[400px]" />
  </div>
  <div class="w-full md:max-w-[60%]">
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[200px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[300px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[500px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[400px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[100px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[100px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[1000px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[300px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[300px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[100px] mb-16" />
    <div class="animate-pulse bg-grey-divider-subdued rounded-xl h-[400px] mb-16" />
  </div>
</div>
